import axiosInstance from './axiosInstance'; 

const API_URL = 'https://idealonline.com.tr/service/idealonline/v1/';

// Kullanıcıyı oturum açma işlemi.
export const login = async (email, password) => {
  try {
    const response = await axiosInstance.post(
      `auth/authenticate`,
      { email, password },
      {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        }
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      return {
        message: error.response.data.message,
        httpStatus: error.response.data.httpStatus,
        dateTime: error.response.data.dateTime
      };
    } else {
      console.error('Error logging in:', error);
      throw error;
    }
  }
};

// Yeni kullanıcı oluşturma işlemi.
export const createUser = async (userData, id) => {
  try {
    const endpoint = id ? `users/CreateUser/${id}` : `users/CreateUser`;
    const response = await axiosInstance.post(endpoint, userData);

    if (response.data.status === 'CREATED') {
      await sendValidationEmail(userData.email);
    }

    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      return {
        message: error.response.data.message,
        httpStatus: error.response.data.httpStatus,
        dateTime: error.response.data.dateTime
      };
    } else {
      console.error('Error creating user:', error);
      throw error;
    }
  }
};

// Kullanıcı yetkilendirme ataması işlemi.
/*
const saveUserAuthorityAssign = async (authorityData) => {
  try {
    const response = await axiosInstance.post(`users/saveUserAuthorityAssign`, authorityData);
    return response.data;
  } catch (error) {
    console.error('Error assigning user authority:', error);
    throw error;
  }
};
*/

// Doğrulama e-postası gönderme işlemi.
export const sendValidationEmail = async (email) => {
  try {
    const response = await axiosInstance.post(`users/UserValidationMail`, { email });
    return response.data;
  } catch (error) {
    console.error('Error sending validation email:', error);
    throw error;
  }
};

// Kullanıcı doğrulama işlemi.
export const sendValidation = async (activationtoken) => {
  try {
    const response = await axiosInstance.post(`users/UserValidation`, { activationtoken });
    return response.data;
  } catch (error) {
    console.error('Error sending validation email:', error);
    throw error;
  }
};

// Şifremi unuttum e-postası gönderme işlemi.
export const forgotPasswordEmail = async (email) => {
  try {
    const response = await axiosInstance.post(`users/ForgotMyPasswordEmail`, { email });
    return response.data;
  } catch (error) {
    console.error('Error sending forgot password email:', error);
    throw error;
  }
};

// Şifre değiştirme işlemi.
export const changePassword = async (data) => {
  try {
    const response = await axiosInstance.post(`users/ForgotMyPasswordChange`, data);
    return response.data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw error;
  }
};

// Kullanıcı detaylarını getirme işlemi.
export const getUserDetails = async (token) => {
  try {
    const response = await axiosInstance.get(`users/userDetail/1`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user details:', error);
    throw error; 
  }
};

// Kullanıcı detaylarını güncelleme işlemi.
export const updateUserDetails = async (data, token) => {
  try {
    const response = await axiosInstance.post(`users/UpdateUser`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating user details:", error);
    throw error;
  }
};

export const getUserPhoto = async (userId, fileName, token) => {
  if (!userId || !fileName) return null;

  const url = `users/displayPhoto/${userId}/${encodeURIComponent(fileName)}`;
  const response = await axiosInstance.get(url, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob',
  });
  return response.data; // Blob döner
};


// ✅ Profil fotoğrafı güncelle
export const updateUserPhoto = async (file, token) => {
  try {
    const fd = new FormData();
    fd.append("photo", file); // swagger'daki alan adı "photo"

    const { data } = await axiosInstance.post(
      `users/photoUpdate`,
      fd,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          // Content-Type belirtme, axios kendisi set eder
        },
      }
    );
    return data; // { status: "OK", message: "...", data: "...?" }
  } catch (error) {
    console.error("Error updating user photo:", error);
    throw error;
  }
};

// ✅ Profil fotoğrafı sil (GET)
export const deleteUserPhoto = async (token) => {
  try {
    const { data } = await axiosInstance.get(
      `users/photoDelete`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return data;
  } catch (error) {
    console.error("Error deleting user photo:", error);
    throw error;
  }
};



// Kullanıcı ayarlarını güncelleme işlemi.
export const saveUserSettingAndUpdate = async (data, token) => {
  try {
    const response = await axiosInstance.post(`users/saveUserSettingAndUpdate`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error saving user settings:", error);
    throw error;
  }
};

// Kullanıcı ayarlarını getirme işlemi.
export const getUserSettingDetail = async (userid, token) => {
  try {
    const response = await axiosInstance.get(`users/UserSettingDetail/${userid}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user settings:", error);
    throw error;
  }
};


export const userInstutationDatabases = async (token) => {
  try {
    const config = {};

    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
      };
    }

    const response = await axiosInstance.get(
      `users/userInstutationDatabases`,
      config
    );

    return response.data;
  } catch (error) {
    console.error("Error userInstutationDatabases:", error);
    throw error;
  }
};

export const checkEmailExists = async (email) => {
  try {
    const response = await axiosInstance.post(
      `users/UserEmailAddressValidation`,
      { email }
    );
    // Servis başarılı yanıt döndürdüğünde, e-posta adresinin geçerli olduğu kabul edilir.
    // Ancak, biz burada "kayıtlı değil" senaryosunu ele alacağız.
    // Bu servis, e-posta adresinin varlığını kontrol etmek için kullanılır.
    // Varsayılan olarak başarılı bir yanıt, e-postanın kayıtlı olmadığını gösterir.
    return response.data;
  } catch (error) {
    // Hata durumunda (örneğin 409 Conflict), e-posta adresinin zaten kayıtlı olduğu anlamına gelir.
    if (error.response && error.response.status === 409) {
      // 409 Conflict (Çakışma) hatası, e-postanın zaten kayıtlı olduğunu belirtir.
      throw new Error("Bu e-posta adresi zaten sistemde kayıtlı.");
    } else {
      console.error('Error checking email:', error);
      throw error;
    }
  }
};

export const getServiceRoleName = async (roleName) => {
  try {
    const response = await axiosInstance.get(
      `users/getServiceRoleName/${roleName}`
    );
    return response.data;
  } catch (error) {
    console.error(error, "Rolename Alınamadı.");
  }
}


